// authUtils.ts - Authentication utilities for chunked uploaders
import { getSession } from '../../../auth/supabase-auth';

/**
 * Get authentication token or throw if not authenticated
 * @throws Error if user is not authenticated
 */
export async function getAuthToken(): Promise<string> {
  const session = await getSession();
  const accessToken = session?.access_token;

  if (!accessToken) {
    throw new Error('Authentication required. Please log in.');
  }

  return accessToken;
}


